<template>
    <div class="omni-basic-search">
        <input id="basic-search"
               v-on:keyup.enter.prevent="submitQuery"
               placeholder="Search parcels"
               v-bind:value="textSearchString"
               v-on:input="$emit('update:textSearch', $event.target.value)"
               title="Text search"
               @paste="onPaste"
               name="query">
    </div>
</template>

<script>
    export default {
        name: "BasicSearch",
        props: {
            textSearch: String
        },
        computed: {
            textSearchString: {
                get() { return this.textSearch; },
                set(value) { this.$emit('update:textSearch', value); }
            }
        },
        methods: {
            submitQuery: function (event) {
                this.$emit('basic-search-submitted', event.target.value)
            },
            onPaste: function (e) {
                if (e.target) {
                    if (typeof(e.clipboardData) !== "undefined" && typeof(e.clipboardData.getData) !== "undefined") {
                        let clipData = e.clipboardData.getData('Text');
                        if (clipData.indexOf('\n') !== -1) {
                            e.preventDefault();
                            this.$nextTick(() => {
                                e.target.value = clipData.replace(/\r?\n/g,'; ').replace(/;\s+$/,'');
                            })
                            return false;
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .omni-basic-search {
        margin: 5px;
        height: 30px;
        min-height: 30px;
        display: flex;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    }
    #basic-search {
        width: 100%;
        height: 100%;
        color: #000;
    }
</style>
